import React from "react";
import { Box, Container, Grid, Typography } from "@mui/material";

import usecase from "../../assets/usecase.png";
import icon7 from "../../assets/icon7.png";
import star from "../../assets/star.png";

const UseCases = () => {
  return (
    <Box>
      <Box textAlign="center" mt={-20}>
        <img src={usecase} alt="abc" srcset="" />
      </Box>
      <Box
        sx={{
          backgroundImage: `url(${star}),linear-gradient(94.36deg, rgba(7, 75, 158, 2) 1.54%, rgba(91, 248, 255, 2) 92.86%)`,
          backgroundSize: "100% 100%",
          height: "100%",
          minHeight: "100vh",
          backgroundRepeat: "no-repeat",
          marginTop: "-12rem",
        }}
      >
        <Container>
          <Typography
            sx={{
              fontSize: { xs: "25px", md: "40px" },
              fontFamily: "Zen Dots",
              fontWeight: "400",
              textAlign: "center",
              pt: 10,
              color: "rgba(255, 255, 255, 1)",
            }}
          >
            use cases
          </Typography>

          <Box py={5}>
            <Grid container spacing={4}>
              {[1, 2, 3, 4, 5, 6, 7, 8].map((item, i) => {
                return (
                  <Grid item md={3} sm={6} xs={12} key={i}>
                    <Box>
                      <img src={icon7} alt="img" />
                      <Typography
                        sx={{
                          fontSize: "16px",
                          fontFamily: "Zen Dots",
                          fontWeight: "400",
                          color: "rgba(255, 255, 255, 1)",
                          my: 1,
                        }}
                      >
                        Institutional Investors
                      </Typography>
                      <Typography
                        sx={{
                          fontSize: "14px",
                          fontFamily: "Inter",
                          fontWeight: "400",
                          color: "rgba(255, 255, 255, 1)",
                        }}
                      >
                        Lorem Ipsum is simply dummy text of the printing and
                        typesetting industry. Lorem Ipsum has been the
                        industry's standard dummy text ever since the 1500s,
                        when an unknown printer took a galley .
                      </Typography>
                    </Box>
                  </Grid>
                );
              })}
            </Grid>
          </Box>
        </Container>
      </Box>
    </Box>
  );
};

export default UseCases;
